var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('pt-button', _vm._b({ staticClass: "preview-tmpl-btn", attrs: { "mini": "" }, on: { "click": _vm.handleClick } }, 'pt-button', _vm.buttonAttrs, false), [_vm._v("\n  " + _vm._s(_vm.buttonAttrs.text) + "\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };